module.exports = __webpack_public_path__ + "img/Frame 1069six.2827800a.png";